import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import type { WithBoundArgs } from '@glint/template';

import PrismTabsContainerContent from './tabs-container/content.gts';
import PrismTabsContainerHeader from './tabs-container/header.gts';

interface PrismTabsContainerSignature {
  Args: {
    activeTabId: string;
    onSelectTab: (tabId: string) => void;
    visibleTabIds: string[];
  };
  Blocks: {
    default: [
      {
        content: WithBoundArgs<typeof PrismTabsContainerContent, 'activeTabId'>;
        header: WithBoundArgs<
          typeof PrismTabsContainerHeader,
          'onSelectTab' | 'activeTabId' | 'visibleTabIds'
        >;
      },
    ];
  };
}

const PrismTabsContainer: TOC<PrismTabsContainerSignature> = <template>
  <div class="prism-tabs-container">
    {{yield
      (hash
        content=(component PrismTabsContainerContent activeTabId=@activeTabId)
        header=(component
          PrismTabsContainerHeader
          activeTabId=@activeTabId
          onSelectTab=@onSelectTab
          visibleTabIds=@visibleTabIds
        )
      )
    }}
  </div>
</template>;

export default PrismTabsContainer;
